<template>
	<component
		:is="tag"
		class="font-prenton-cond text-5xl tracking-2xl uppercase lg:text-6xl lg:tracking-xl xl:text-8xl"
		:class="{'sr-only': isHidden}"
	>
		<slot></slot>
	</component>
</template>

<script lang="ts" setup>
withDefaults(
	defineProps<{
		tag?: string;
		isHidden?: boolean;
	}>(),
	{
		tag: "h3",
	},
);
</script>
